<template>
    <div class="login_page">
        <div class="loginBg1 loginBg">
            
        </div>
        <div class="loginBg2 loginBg">
            
        </div>
        <div class="loginBg3 loginBg">
            
        </div>
        <div class="mainArea">
            <div class="logo">
                <img src="../assets/img/login/logo.png" alt="">
            </div>
            <div class="formLogin">
                <div class="formArea">
                    <div class="title">欢迎登录</div>
                    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left" label-width="90px">
                        <el-form-item prop="username" label="用户名">
                            <el-input ref="username" v-model="loginForm.username" placeholder="请输入用户名" name="username" type="text" @keyup.enter.native="handleLogin" autocomplete="off">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password" label="密码" class='pwd'>
                            <el-input :key="passwordType" ref="password" v-model="loginForm.password" :type="passwordType" placeholder="请输入密码" name="password" autocomplete="off" @keyup.enter.native="handleLogin">
                            </el-input>
                            <span class="show-pwd" @click="showPwd">
                                <i class="iconfont" :class="passwordType === 'password' ? 'icon-yanjing' : 'icon-yanjing1'"></i>
                            </span>
                        </el-form-item>
                        <!-- <el-form-item prop="vcode" label="验证码" class="vsCode">
                            <el-input :key="passwordType" v-model="loginForm.vcode" type="text" placeholder="请输入验证码" name="password" autocomplete="off" @keyup.enter.native="handleLogin">
                            </el-input>
                            <a href="javascript:;" style="-webkit-autofill:-webkit-box-shadow: 0 0 0 1000px red inset" class="icon tog-paw code_img" title="点击图片刷新">
                                <img :src="imgsrc" alt @click="refreshRandomCode" />
                            </a>
                        </el-form-item> -->
                        <el-checkbox v-model="remberPsdCheck">记住密码</el-checkbox>

                        <el-button :loading="loading" type="primary" @click.native.prevent="handleLogin">
                            登<span></span> 录
                        </el-button>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import { mapActions } from "vuex";
import md5 from "js-md5";
import bg1 from "@/assets/img/login/loginBg1.png";
import bg2 from "@/assets/img/login/loginBg2.png";
import bg3 from "@/assets/img/login/loginBg3.png";
import { setInterval } from 'timers';
export default {
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value && (value.length < 2 || value.length > 20)) {
        callback(new Error("请输入2-20个字符"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("请输入至少六位密码"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: "",
        // vcode: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入用户名" },
          { validator: validateUsername, trigger: "blur" }
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ],
        // vcode: [
        //   {
        //     required: true,
        //     trigger: "blur",
        //     message: "请输入验证码"
        //   }
        // ]
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
      imgsrc: "",
      remberPsdCheck: true,
      imgs: [bg1,bg2,bg3],
      active: 0,
      time:''
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created() {
    this.$nextTick(() => {
      let user = JSON.parse(window.localStorage.getItem("user"));
      if (user) {
        this.loginForm.username = user.usern;
        this.loginForm.password = user.psd;
      }
      // this.refreshRandomCode();
    });
  },
  methods: {
    ...mapActions(["login", "getVerificationCode"]),
    refreshRandomCode() {
      this.$store.dispatch("generateVcode").then(res => {
        this.imgsrc = res.body.data;
      });
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          let params = {
            username: this.loginForm.username,
            password: md5(this.loginForm.password),
            // vcode: this.loginForm.vcode
          };
          this.login(params)
            .then(res => {
              if (res.body.errorCode == 0) {
                console.log("登录成功", res, this.redirect);
                if (this.remberPsdCheck) {
                  let userData = {
                    usern: this.loginForm.username,
                    psd: this.loginForm.password
                  };
                  let userDataStr = JSON.stringify(userData);
                  window.localStorage.setItem("user", userDataStr);
                } else {
                  window.localStorage.removeItem("user");
                }
                this.$router.push({
                  path: this.redirect ? this.redirect : "/home"
                });
              } else {
                if (res.body.errorCode == 403) {
                  this.refreshRandomCode();
                }
              }
              this.loading = false;
            })
            .catch(err => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login_page {
  width: 100%;
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  overflow-y: auto;
  background-size: cover;
  .loginBg{
    width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
    left: 0;
    right: 0;
    bottom: 0;
	color: transparent;
	background-size: cover;
	background-position: center;
	background-repeat: none;
	opacity: 0;
	z-index: -2;
	-webkit-backface-visibility: hidden;
	-webkit-animation: imageAnimation 25s linear infinite 0s;
	-moz-animation: imageAnimation 25s linear infinite 0s;
	-o-animation: imageAnimation 25s linear infinite 0s;
	-ms-animation: imageAnimation 25s linear infinite 0s;
	animation: imageAnimation 25s linear infinite 0s
  }
  .loginBg1{
      background-image: url('../assets/img/login/loginBg1.png');
  }
  .loginBg2{
    background-image: url('../assets/img/login/loginBg2.png');
    -webkit-animation-delay: 10s;
	-moz-animation-delay: 10s;
	-o-animation-delay: 10s;
	-ms-animation-delay: 10s;
	animation-delay: 10s
  }
  .loginBg3{
    background-image: url('../assets/img/login/loginBg3.png');
    -webkit-animation-delay: 16s;
	-moz-animation-delay: 16s;
	-o-animation-delay: 16s;
	-ms-animation-delay: 16s;
	animation-delay: 16s
  }
  @keyframes imageAnimation {
	0% {
		opacity: 0.1;
		// -webkit-animation-timing-function: ease-in
	}
 
	20% {
		opacity: 1;
		// -webkit-transform: scale(1.05);
		// -webkit-animation-timing-function: ease-out
	}
 
	40% {
		opacity: 1;
		// -webkit-transform: scale(1.1) rotate(0)
	}
 
	60% {
		opacity: 0.1;
		// -webkit-transform: scale(1.1) rotate(0)
    }
    
	100% {
		opacity: 0.1
	}
}
  .mainArea {
    width: 920px;
    margin: 0 auto;
    .logo {
      padding-top: 100px;
      img {
        width: 450px;
      }
    }
    .formLogin {
      display: flex;
      justify-content: flex-end;
      margin-top: 40px;
      .formArea {
        width: 370px;
        background: #fff;
        padding: 0 40px;
        border-radius: 4px;
        box-shadow: 0px 2px 5px #666;
        ::v-deep .el-form-item {
          padding-bottom: 18px;
          margin-bottom: 20px;
          position: relative;
          &.el-form-item--small .el-form-item__error {
            padding-top: 0px;
          }
          &.vsCode .el-input__inner {
            padding-right: 85px;
          }
          &.pwd .el-input__inner {
            padding-right: 35px;
          }
          .show-pwd {
            position: absolute;
            right: 5px;
            cursor: pointer;
            i {
              font-size: 22px;
              color: #308ff0;
            }
          }
          .code_img {
            position: absolute;
            right: 5px;
            top: 4px;
          }
          .el-form-item__label {
            font-size: 18px;
            color: #666666;
          }
          border-bottom: 1px solid #eee;
          input {
            border: none;
            font-size: 18px;
            color: #666666;
            padding: 0;
          }
        }
        .title {
          font-size: 34px;
          color: #222;
          font-weight: bold;
          padding: 30px 0;
          text-align: center;
        }
        button {
          height: 55px;
          background: #308ff0;
          width: 100%;
          margin: 40px 0px;
          font-size: 22px;
          span {
            padding: 0 10px;
          }
        }
      }
      ::v-deep .el-checkbox {
        .el-checkbox__inner {
          width: 16px;
          height: 16px;
          border-color: #999999;
          top: -1px;
          &::after {
            height: 10px;
            top: 0px;
            left: 5px;
          }
        }
        .el-checkbox__label {
          font-size: 16px;
          color: #999999;
        }
      }
    }
  }
}
</style>
